/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { StatisticsServiceProvider } from './service/StatisticsServiceProvider';

// Components
import { dashboardComponent } from './component/Dashboard';
import { gmaoActionRequestsByCauseChartComponent } from './component/GmaoActionRequestsByCauseChart';
import { gmaoActionRequestsByStatusMetricComponent } from './component/GmaoActionRequestsByStatusMetric';
import { gmaoActionRequestsByStatusChartComponent } from './component/GmaoActionRequestsByStatusChart';
import { gmaoGrtRateMetricComponent } from './component/GmaoGrtRateMetric';
import { gmaoEquipmentAvailabilityMetricComponent } from './component/GmaoEquipmentAvailabilityMetric';
import { gmaoFailingEquipmentsMetricComponent } from './component/GmaoFailingEquipmentsMetric';
import { gmaoPreventiveSheetsByStatusChartComponent } from './component/GmaoPreventiveSheetsByStatusChart';
import { statisticsBoardComponent } from './component/StatisticsBoard';

angular.module('serfimtic.gmao.statistics', ['ui.router', 'ngResource'])
.provider('statisticsService', StatisticsServiceProvider)
.component('dashboard', dashboardComponent)
.component('gmaoActionRequestsByCauseChart', gmaoActionRequestsByCauseChartComponent)
.component('gmaoActionRequestsByStatusMetric', gmaoActionRequestsByStatusMetricComponent)
.component('gmaoActionRequestsByStatusChart', gmaoActionRequestsByStatusChartComponent)
.component('gmaoGrtRateMetric', gmaoGrtRateMetricComponent)
.component('gmaoEquipmentAvailabilityMetric', gmaoEquipmentAvailabilityMetricComponent)
.component('gmaoFailingEquipmentsMetric', gmaoFailingEquipmentsMetricComponent)
.component('gmaoPreventiveSheetsByStatusChart', gmaoPreventiveSheetsByStatusChartComponent)
.component('statisticsBoard', statisticsBoardComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.componentState('gmao.dashboard', 'dashboard', '/dashboard', 'ui.dashboard', ['USER']))
        .state(State.abstractUrlState('gmao.statistics', '/statistics', ['ADMIN', 'STATS']))
        .state(State.componentState('gmao.statistics.board', 'statisticsBoard', '/board',
            'ui.statistics.board'));
})
.config(statisticsServiceProvider => {
    /** @ngInject */
    statisticsServiceProvider.setResourceUrl(Configuration.STATISTICS_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/StatisticsModule.js